<script lang="ts">
	import { page } from '$app/state'
	import LogoTenantHandler from '$lib/components/logo/LogoTenantHandler.svelte'
	import { Error } from '@repo/ui'
</script>

<Error>
	{#snippet logo()}
		<LogoTenantHandler forceLightMode />
	{/snippet}
	{#snippet title()}
		{page.status}: {page.error?.message}
	{/snippet}
	<p>
		Go to:
		<br />
		<a class="underline hover:no-underline" href="/">Dashboard</a>
	</p>
</Error>
